
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Loading',
  props: {
    loadingStyle: {
      type: Object,
      default: () => ({
        width: '50px',
        height: '50px',
      }),
    },
  },
});
